/*
	STATE
*/
//------------------------------------------------------------
// IMPORTS
//------------------------------------------------------------

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

//------------------------------------------------------------
// STATE
//------------------------------------------------------------

const state = {
	openWindows: [],
	closedWindows: []
}

//------------------------------------------------------------
// EXPORT
//------------------------------------------------------------

export default {
	state,
	getters,
	actions,
    mutations
}
//===========================================
//
//===========================================